export default __webpack_public_path__ + "static/media/happy-feet.58859f6f.jpg";